export const AvailableCalculationOperations = [
  {name: "Min", value: 'min'},
  {name: "Max", value: 'max'},
  {name: "Avg", value: 'avg'},
  {name: "Sum", value: 'sum'},
  {name: "Multiply", value: 'mul'},
  {name: "Deduction", value: 'deduction'},
  {name: "Division", value: 'division'},
  {name: "Open Formula", value: 'open_formula'}
]
